import ReqClient from './request.class'

export async function getImageLabelPage(params) {
  const Req = new ReqClient({
    url: '/api/ptom/designer/queryImageLabelReport',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取素材统计列表
export async function getMaterialRecordData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/media/materialReport',
    method: 'POST',
    timeout: 300000,
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获素材分析分页列表
export async function getMaterialAnalysisData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/material/analyze/page',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 更新素材分析备注
export async function updateMaterialAnalysisRemark(data) {
  const Req = new ReqClient({
    url: '/api/ptom/material/analyze/updateRemark',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 素材分析数据导出
export async function exportMaterialAnalysisData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/material/analyze/down',
    method: 'POST',
    data,
    responseType: 'blob'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取素材统计详情
export async function getMaterialRecordDetail(params) {
  const Req = new ReqClient({
    url: '/api/ptom/media/materialReportDetail',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取素材分析广告数据详情
export async function getMaterialAnalysisDetail(data) {
  const Req = new ReqClient({
    url: '/api/ptom/material/analyze/planData',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 素材分析广告数据详情导出
export async function exportMaterialAnalysisDetail(data) {
  const Req = new ReqClient({
    url: '/api/ptom/material/analyze/downPlanData',
    method: 'POST',
    data,
    responseType: 'blob'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获到素材生命周期详情
export async function getMaterialLifeCycle(params) {
  const Req = new ReqClient({
    url: '/api/ptom/media/getMaterialLifeCycleData',
    timeout: 300000,
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获到素材分析分日数据详情
export async function getMaterialAnalysisDailyData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/material/analyze/dayData',
    timeout: 300000,
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获到素材分析评论数据
export async function getMaterialAnalysisCommentList(data) {
  const Req = new ReqClient({
    url: '/api/ptom/comment/queryByPage',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 评论置顶
export async function materialCommentSetTop(data) {
  const Req = new ReqClient({
    url: '/api/ptom/comment/stick',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 评论隐藏
export async function materialCommentSetInvisible(data) {
  const Req = new ReqClient({
    url: '/api/ptom/comment/hide',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 评论回复
export async function materialCommentReply(data) {
  const Req = new ReqClient({
    url: '/api/ptom/comment/reply',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 素材分析分日数据详情导出
export async function exportMaterialAnalysisDailyData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/material/analyze/downDayData',
    method: 'POST',
    data,
    responseType: 'blob'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获到素材标签曲线详情
export async function getLabelLifeCycle(data) {
  const Req = new ReqClient({
    url: '/api/ptom/media/getMaterialLabelData',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获到素材分析内容曲线详情
export async function getLabelAnalysisData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/material/analyze/labelData',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 素材分析内容标签曲线数据导出
export async function exportLabelAnalysisData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/material/analyze/downLabelData',
    method: 'POST',
    data,
    responseType: 'blob'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获到素材分析标签组分析
export async function getLabelGroupAnalysisData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/material/analyze/labelGroupData',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 素材分析内容标签曲线数据导出
export async function exportLabelGroupAnalysisData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/material/analyze/downLabelGroupData',
    method: 'POST',
    data,
    responseType: 'blob'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 选择素材对比
export async function compareMaterialRecord(data) {
  const Req = new ReqClient({
    url: '/api/ptom/media/materialDataComparison',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 素材播放曲线
export async function getVideoPlayDatas(data) {
  const Req = new ReqClient({
    url: '/api/ptom/media/getVideoPlayDatas',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询素材管控规则列表
export async function getMaterLimitRuleList(params) {
  const Req = new ReqClient({
    url: '/api/ptom/imagelimitrule/page',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 新增素材管控规则
export async function addMaterLimitRules(data) {
  const Req = new ReqClient({
    url: '/api/ptom/imagelimitrule/add',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取素材管控规则详情
export async function getMaterLimitRuleDetail(params) {
  const Req = new ReqClient({
    url: '/api/ptom/imagelimitrule/queryDetail',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 修改素材管控规则
export async function editMaterLimitRules(data) {
  const Req = new ReqClient({
    url: '/api/ptom/imagelimitrule/update',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 删除素材管控规则
export async function delMaterLimitRules(params) {
  const Req = new ReqClient({
    url: '/api/ptom/imagelimitrule/del',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取海外报表数据
export async function getOverseasPage(data) {
  const Req = new ReqClient({
    url: '/api/ptom/overseas/page',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取海外报表详情数据
export async function getOverseasDetailPage(data) {
  const Req = new ReqClient({
    url: '/api/ptom/overseas/detailPage',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取海外国家数据
export async function getOverseasCountry(params) {
  const Req = new ReqClient({
    url: '/api/ptom/overseas/country/list',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取抖音达人综合报表
export async function getDouyinComplexReport(data) {
  const Req = new ReqClient({
    url: 'api/ptom/complexReport/douyinExpert',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 统计抖音达人综合报表
export async function countDouyinReportData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/complexReport/countDouyinReport',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 导出抖音达人综合报表
export async function exportDouyinReportData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/complexReport/exportDouyinReport',
    method: 'POST',
    data,
    responseType: 'blob'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取广告位综合报表
export async function getAdPositionComplexReport(data) {
  const Req = new ReqClient({
    url: '/api/ptom/siteSetReport/page',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 统计广告位综合报表
export async function countAdPositionReportData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/siteSetReport/countReportData',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 导出广告位综合报表
export async function exportAdPositionReportData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/siteSetReport/exportReportData ',
    method: 'POST',
    data,
    responseType: 'blob'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取综合报表
export async function getComplexReport(data) {
  const Req = new ReqClient({
    url: '/api/ptom/complexReport/page',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取综合效果报表投放类型选项
export async function getComplexReportDeliveryTypeOptions(params) {
  const Req = new ReqClient({
    url: '/api/ptom/complexReport/deliveryTypeOptions',
    method: 'GET',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 统计综合报表导出
export async function exportReportData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/complexReport/exportReportData',
    method: 'POST',
    data,
    responseType: 'blob'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 统计综合报表
export async function countReportData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/complexReport/countReportData',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 综合报表：查询广告计划
export async function getQueryPlan(data) {
  const Req = new ReqClient({
    url: '/api/ptom/complexReport/queryPlan',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 综合报表：查询素材
export async function getQueryImage(data) {
  const Req = new ReqClient({
    url: '/api/ptom/complexReport/queryImage',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 获取每日报表推送任务列表
 * @param {*} data
 */
export async function getDailyPushTaskList(data) {
  const Req = new ReqClient({
    url: '/api/ptom/super_report/page',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 更新任务状态
 * @param {*} data
 */
export async function updateDailyReportTaskStatusById(data) {
  const Req = new ReqClient({
    url: '/api/ptom/super_report/updateStatus',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 根据任务id获取发送记录
 * @param {*} data
 */
export async function getTaskSendRecordsById(data) {
  const Req = new ReqClient({
    url: '/api/ptom/super_report/sendrecord/page',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 根据发送记录重新发送
 * @param {*} data
 */
export async function reTryRecordById(data) {
  const Req = new ReqClient({
    url: '/api/ptom/super_report/sendrecord/retry',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 根据发送记录id获取记录详情
 * @param {*} data
 */
export async function queryByRecordId(data) {
  const Req = new ReqClient({
    url: '/api/ptom/super_report/queryByRecordId',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 根据发送记录重新发送
 * @param {*} data
 */
export async function addOrUpdateDailyTask(data) {
  const Req = new ReqClient({
    url: '/api/ptom/super_report/addOrUpdate',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 根据任务id获取任务详情
 * @param {*} data
 */
export async function getTaskDetailById(data) {
  const Req = new ReqClient({
    url: '/api/ptom/super_report/queryById',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 查询游戏组的平台和中间件游戏id
 * @param {*} data
 */
export async function getSameMiddlewareGame(params) {
  const Req = new ReqClient({
    url: '/api/game/queryGameGroupMgameId',
    method: 'GET',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 查询游戏组的平台和中间件游戏id
 * @param {*} data
 */
export async function appgroupQueryGame(data) {
  const Req = new ReqClient({
    url: '/api/game/queryGame',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 游戏回款标准新增/修改
export async function addOrUpdateGameRoi(data) {
  const Req = new ReqClient({
    url: '/api/ptom/xlssettings/gameroi/addOrUpdate',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 游戏回款列表查询
export async function getGameRoiPage(params) {
  const Req = new ReqClient({
    url: '/api/ptom/xlssettings/gameroi/page',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
// 游戏回款标准导入
export async function importGameRoi(params) {
  const Req = new ReqClient({
    url: '/api/ptom/xlssettings/gameroi/importData',
    method: 'POST',
    params
  })
  try {
    return await Req.reqFormData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
// 游戏回款标准单条查询反显
export async function getGameRoi(params) {
  const Req = new ReqClient({
    url: '/api/ptom/xlssettings/gameroi/get',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
// 游戏回款标准删除
export async function delGameRoi(params) {
  const Req = new ReqClient({
    url: '/api/ptom/xlssettings/gameroi/delete',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
// 市场投放kpi设置分页查询
export async function getKpiPage(params) {
  const Req = new ReqClient({
    url: '/api/ptom/xlssettings/kpi/page',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
// 市场投放kpi导入
export async function importKpi(params) {
  const Req = new ReqClient({
    url: '/api/ptom/xlssettings/kpi/importData',
    method: 'POST',
    params
  })
  try {
    return await Req.reqFormData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 市场投放kpi新增/修改
export async function addOrUpdateMarketingKpi(data) {
  const Req = new ReqClient({
    url: '/api/ptom/xlssettings/kpi/addOrUpdate',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 市场投放kpi单条查询反显
export async function getMarketingKpi(params) {
  const Req = new ReqClient({
    url: '/api/ptom/xlssettings/kpi/get',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
// 市场投放kpi单条删除
export async function delMarketingKpi(params) {
  const Req = new ReqClient({
    url: '/api/ptom/xlssettings/kpi/delete',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 游戏等级设置
export async function setGameLevel(data) {
  const Req = new ReqClient({
    url: '/api/ptom/complexReport/setLevelPassConfig',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 市场投放kpi单条查询反显
export async function getGamePassLevelConfig(params) {
  const Req = new ReqClient({
    url: '/api/ptom/complexReport/getLevelPassConfig',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @page: AI工具-数据上报管控
 * @description: 分页查询数据上报管控信息
 */
export async function getDataReportingInfoByPage(data) {
  const Req = new ReqClient({
    url: '/api/ptom/dataReporting/queryDataReportingInfoByPage',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @page: AI工具-数据上报管控
 * @description: 修改数据上报管控配置的状态（关闭、开启、删除）
 */
export async function updateDataReportConfigStatus(data) {
  const Req = new ReqClient({
    url: '/api/ptom/dataReporting/udStatusForDataReportingConfig',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @page: AI工具-数据上报管控
 * @description: 新增编辑数据上报管控配置
 */
export async function submitReortingConfig(data) {
  const Req = new ReqClient({
    url: '/api/ptom/dataReporting/addOrUpdateDataReportingConfig',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @page: 数据上报管控
 * @description: 获取全部中间件游戏信息
 */
export async function getAllMgameInfo() {
  const Req = new ReqClient({
    url: '/api/ptom/dataReporting/queryAllMgameInfo',
    method: 'POST'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 获取小程序综合效果报表分页数据
 * @param {*} data
 */
export async function getMiniGameComplexReport(data) {
  const Req = new ReqClient({
    url: '/api/ptom/xcx/complexReport/page',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 导出小程序综合效果报表数据
 * @param {*} data
 */
export async function exportMiniGameComplexReport(data) {
  const Req = new ReqClient({
    url: '/api/ptom/xcx/complexReport/exportReportData',
    method: 'POST',
    data,
    responseType: 'blob'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 小程序综合效果报表数据导出前校验
 * @param {*} data
 */
export async function validExportMiniGameComplexReport(data) {
  const Req = new ReqClient({
    url: '/api/ptom/xcx/complexReport/countReportData',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @page: 数据上报管控
 * @description: 分页获取日志列表
 */
export async function getReportLogByPage(data) {
  const Req = new ReqClient({
    url: '/api/ptom/callback/filterlog/page',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function getDownloadCenterFileByTask(name) {
  const Req = new ReqClient({
    url: `/ptom/mail/downCosList?type=5&name=${name}&suffix=.xlsx`,
    method: 'POST',
    responseType: 'blob'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 下载中心新建下载任务
 * @param {*} data
 * @return {*}
 */
export async function initDownloadCenterTask(data) {
  const Req = new ReqClient({
    url: '/api/ptom/downloadCentre/downloadReportData',
    method: 'POST',
    data: {
      ...data,
      queryCondition: JSON.stringify({ ...data.queryCondition, isAsync: true })
    },
    responseType: 'blob'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    console.log('handleError eeeeeeee output: ', e)
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 下载中心任务列表
 * @param {*} data
 * @return {*}
 */
export async function getDownloadCenterByPage(data) {
  const Req = new ReqClient({
    url: '/api/ptom/downloadCentre/pagQueryDownloadInfo',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 小游戏广告收益配置保存
 * @param {*} data
 * @return {*}
 */
export async function getMiniGameAdProfitConfig(params) {
  const Req = new ReqClient({
    url: '/api/ptom/adprofit/query',
    method: 'GET',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 小游戏广告收益配置验证
 * @param {*} data
 * @return {*}
 */
export async function verifyMiniGameAdProfitConfig(data) {
  const Req = new ReqClient({
    url: '/api/ptom/adprofit/verifyConfig',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 小游戏广告收益配置保存
 * @param {*} data
 * @return {*}
 */
export async function saveMiniGameAdProfitConfig(data) {
  const Req = new ReqClient({
    url: '/api/ptom/adprofit/save',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 标签分析
 * @param {*} data
 * @return {*}
 */
export async function queryLabelAnalysisDataByPage(data) {
  const Req = new ReqClient({
    url: '/api/ptom/material/label/complex/page',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 标签分析导出
 * @param {*} data
 * @return {*}
 */
export async function exportLabelAnalysisTableData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/material/label/complex/down',
    method: 'POST',
    data,
    responseType: 'blob'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
